import { useState, useCallback } from "react";
import { PORTFOLIO, EntityType } from "../utils/constants";

/**
 * Hook for managing AddEntityModal state
 * Handles modal open/close and entity type selection
 */
export const useAddEntityModal = () => {
    const [open, setOpen] = useState(false);
    const [entityType, setEntityType] = useState<EntityType>(PORTFOLIO);
    const [selectedPortfolioId, setSelectedPortfolioId] = useState<string | null>(null);

    const openModal = useCallback((type?: EntityType, portfolioId?: string) => {
        setEntityType(type ?? PORTFOLIO);
        setSelectedPortfolioId(portfolioId ?? null);
        setOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setOpen(false);
        setEntityType(PORTFOLIO);
        setSelectedPortfolioId(null);
    }, []);

    return {
        open,
        entityType,
        selectedPortfolioId,
        openModal,
        closeModal,
        setEntityType,
        setSelectedPortfolioId,
    };
};
